import { render, staticRenderFns } from "./PageCities.vue?vue&type=template&id=06a6888a&"
import script from "./PageCities.vue?vue&type=script&lang=js&"
export * from "./PageCities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06a6888a')) {
      api.createRecord('06a6888a', component.options)
    } else {
      api.reload('06a6888a', component.options)
    }
    module.hot.accept("./PageCities.vue?vue&type=template&id=06a6888a&", function () {
      api.rerender('06a6888a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/cities/PageCities.vue"
export default component.exports